import React from 'react';
import { getAppEnv } from '../../../../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const BusHireComponent = ({ showBusHire }) => {
  const openBusHireLink = () => {
    window.location = Object(
      'https://makemytrip.redbus.in/bushire/?intid=NewHlpBusWidget'
    );
  };

  return showBusHire ? (
    <div
      id="bus_hire"
      style={{ height: '128px' }}
      onClick={openBusHireLink}
      className="appendTop10 appendBottom10 appendLeft16 appendRight16"
    >
      <img
        className="fullWidth"
        height={128}
        src={`${PUBLIC_URL}/static/public/bus_hire_banner.webp`}
      />
    </div>
  ) : null;
};
